export default __webpack_public_path__ + "static/media/epi4Vid.69876ecd.jpg";